"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var MetadataHierarchyRowDTO_1 = require("../model/MetadataHierarchyRowDTO");

var MetadataHierarchyRowDTOConverter_1 = require("./MetadataHierarchyRowDTOConverter");

var MetadataHierarchyRowDTOConverterImpl =
/*#__PURE__*/
function (_MetadataHierarchyRow) {
  _inherits(MetadataHierarchyRowDTOConverterImpl, _MetadataHierarchyRow);

  function MetadataHierarchyRowDTOConverterImpl() {
    _classCallCheck(this, MetadataHierarchyRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MetadataHierarchyRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(MetadataHierarchyRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO(MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO.schema.categoryExternalId.valueOfField(source), MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO.schema.categoryName.valueOfField(source), MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO.schema.categoryNumber.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        categoryExternalId: source.categoryExternalId,
        categoryName: source.categoryName,
        categoryNumber: source.categoryNumber
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "objectToArray",
    value: function objectToArray(instance, conversions) {
      var document = this.toDocument(instance, conversions);
      var arr = MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO.dataOrder.map(function (key) {
        return document[key];
      });
      return immutable_1.List(arr);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(source, conversions) {
      var data = {};
      MetadataHierarchyRowDTO_1.MetadataHierarchyRowDTO.dataOrder.forEach(function (value, index) {
        if (typeof source[index] !== 'undefined') {
          data[value] = source[index];
        }
      });
      return this.toObject(data, conversions);
    }
  }]);

  return MetadataHierarchyRowDTOConverterImpl;
}(MetadataHierarchyRowDTOConverter_1.MetadataHierarchyRowDTOConverter);

exports.MetadataHierarchyRowDTOConverterImpl = MetadataHierarchyRowDTOConverterImpl;